export default __webpack_public_path__ + "static/media/banner1.bd08422d.png";